export default "__VITE_ASSET__DZ34DSkN__"